import { createContext } from 'react';

export interface OrganizationRole {
  id?: string;
  name?: string;
  slug?: string;
  roles: string[];
}

export interface AuthUser {
  organizations?: OrganizationRole[];
  user?: {
    id: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
  };
}

export interface AuthContextType {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (user: AuthUser) => void;
  logout: () => void;
  getOrganizationSlug: () => string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
